module.exports = __webpack_public_path__ + "img/Nicaragua.fc5ffd0b.gif";